import type { ReadonlyRecord } from '../../../utils'

import type { Translation } from '../../../domain'

import en from './en.json'

export const enTranslation: ReadonlyRecord<Translation, string> = en
